<template>
    <v-dialog :value="visible" max-width="560" :persistent="salvando" @input="$emit('close')">
        <v-card>
            <v-card-title>
                {{ indicacao ? `Indicação #${indicacao.id}` : 'Nova indicação' }}
                <v-spacer/>
                <v-btn icon :disabled="salvando" @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <BuscaRemota
                    v-if="!indicacao"
                    v-model="form.empresa_id"
                    tipo="empresas"
                    label="Loja que indicou *"
                />
                <v-text-field
                    v-else
                    :value="textoEmpresa(indicacao.empresa, indicacao.empresa_id)"
                    label="Loja que indicou"
                    outlined
                    dense
                    disabled
                />

                <BuscaRemota
                    v-model="form.contato_id"
                    :inicial="leadInicial"
                    :disabled="vinculoTravado"
                    tipo="contatos"
                    label="Lead indicado"
                    hint="Com o lead, o cadastro da empresa é encontrado sozinho."
                    class="mb-2"
                />

                <BuscaRemota
                    v-model="form.empresa_indicada_id"
                    :inicial="empresaIndicadaInicial"
                    :disabled="vinculoTravado"
                    :hint="vinculoTravado ? 'O indicado já pagou: o vínculo não muda mais.' : ''"
                    tipo="empresas"
                    label="Empresa indicada"
                />

                <v-text-field
                    v-model="form.nome_indicado"
                    label="Nome do indicado"
                    :hint="indicacao ? '' : 'Vem do lead ou da empresa quando ficar em branco.'"
                    :persistent-hint="!indicacao"
                    outlined
                    dense
                    class="mb-2"
                />

                <v-textarea
                    v-model="form.observacao"
                    label="Observação"
                    outlined
                    dense
                    auto-grow
                    rows="2"
                    hide-details
                />
            </v-card-text>

            <v-card-actions>
                <v-btn text :disabled="salvando" @click="$emit('close')">Cancelar</v-btn>
                <v-spacer/>
                <v-btn color="primary" depressed :loading="salvando" :disabled="!podeSalvar" @click="salvar">
                    Salvar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import BuscaRemota from './BuscaRemota.vue';

export default {
    name: 'IndicacaoDialog',

    components: { BuscaRemota },

    props: {
        visible: { type: Boolean, default: false },
        indicacao: { type: Object, default: null },
    },

    data: () => ({
        salvando: false,
        form: {},
    }),

    computed: {
        vinculoTravado() {
            return !!this.indicacao && this.indicacao.etapa === 'cliente';
        },

        leadInicial() {
            const c = this.indicacao && this.indicacao.contato;
            return c ? { id: c.id, texto: `${c.nome} · ${c.whatsapp || 'sem WhatsApp'} (lead #${c.id})` } : null;
        },

        empresaIndicadaInicial() {
            const i = this.indicacao;
            return i && i.empresa_indicada_id
                ? { id: i.empresa_indicada_id, texto: this.textoEmpresa(i.empresa_indicada, i.empresa_indicada_id) }
                : null;
        },

        podeSalvar() {
            if (this.indicacao) return true;

            return !!this.form.empresa_id
                && !!(this.form.contato_id || this.form.empresa_indicada_id || (this.form.nome_indicado || '').trim());
        },
    },

    watch: {
        visible(aberto) {
            if (!aberto) return;

            const i = this.indicacao;

            this.form = {
                empresa_id: i ? i.empresa_id : null,
                contato_id: i ? i.contato_id : null,
                empresa_indicada_id: i ? i.empresa_indicada_id : null,
                nome_indicado: i ? i.nome_indicado : '',
                observacao: i ? i.observacao : '',
            };
        },
    },

    methods: {
        textoEmpresa(empresa, id) {
            return `#${id} ${empresa ? empresa.fantasia || '' : ''}`;
        },

        async salvar() {
            this.salvando = true;

            try {
                const { data } = this.indicacao
                    ? await this.$http.put(`gestao/indicacoes/${this.indicacao.id}`, this.form)
                    : await this.$http.post('gestao/indicacoes', this.form);

                if (data.type !== 'success') {
                    this.notify(data.msg, 'warning');
                    return;
                }

                this.notify(this.indicacao ? 'Indicação atualizada' : 'Indicação cadastrada');
                this.$emit('salvo', data.data);
            } catch (e) {
                this.notify('Não foi possível salvar a indicação', 'warning');
            } finally {
                this.salvando = false;
            }
        },
    },
};
</script>
